import { render, staticRenderFns } from "./courseYqjx.vue?vue&type=template&id=09b9e412&scoped=true&"
import script from "./courseYqjx.vue?vue&type=script&lang=js&"
export * from "./courseYqjx.vue?vue&type=script&lang=js&"
import style0 from "./courseYqjx.vue?vue&type=style&index=0&id=09b9e412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9e412",
  null
  
)

export default component.exports